import type { SubmissionEvaluationResult } from '@/common/api/models';

/** Formal and Description need Good, Analysis needs Very Good, Application has no requirement. */
export const EVAL_CARD_LAB_MIN_LEVELS: Record<string, string> = {
  formal: 'good',
  analysis: 'very_good',
  description: 'good',
};

export type EvalCardLabState = 'not-ready' | 'ready' | 'edited';

export const EVAL_CARD_LAB_STATES: EvalCardLabState[] = ['not-ready', 'ready', 'edited'];

const NOT_READY_EVALUATION = {
  formal: { level: 'satisfactory', description: '' },
  analysis: { level: 'good', description: '' },
  description: { level: 'good', description: '' },
  application: { level: 'satisfactory', description: '' },
} as SubmissionEvaluationResult;

const READY_EVALUATION = {
  formal: { level: 'good', description: '' },
  analysis: { level: 'very_good', description: '' },
  description: { level: 'good', description: '' },
  application: { level: 'satisfactory', description: '' },
} as SubmissionEvaluationResult;

const EVALUATED_AT = 1_000;

/** Store slice per lab state; `edited` is the ready draft saved again after its evaluation. */
export const EVAL_CARD_LAB_STATE_FIXTURES: Record<EvalCardLabState, {
  evaluation: SubmissionEvaluationResult;
  lastSavedAt: number;
}> = {
  'not-ready': { evaluation: NOT_READY_EVALUATION, lastSavedAt: EVALUATED_AT - 1 },
  ready: { evaluation: READY_EVALUATION, lastSavedAt: EVALUATED_AT - 1 },
  edited: { evaluation: READY_EVALUATION, lastSavedAt: EVALUATED_AT + 1 },
};

export const EVAL_CARD_LAB_EVALUATED_AT = EVALUATED_AT;

export const EVAL_CARD_LAB_DIMENSIONS = [
  'formal',
  'analysis',
  'description',
  'application',
] as const;

/** Tenant grading slice so the lab card uses the real dimension colors and level labels. */
export const EVAL_CARD_LAB_GRADING_SETTINGS = {
  evalDimensions: {
    formal: { description: 'Formal', maxWeight: 0.25 },
    analysis: { description: 'Analysis', maxWeight: null },
    description: { description: 'Description', maxWeight: null },
    application: { description: 'Application', maxWeight: null },
  },
  performanceLevels: [
    {
      id: 'needs_improvement',
      performancePercent: 0,
      label: 'Needs Improvement',
      description: '',
    },
    {
      id: 'satisfactory',
      performancePercent: 0.33,
      label: 'Satisfactory',
      description: '',
    },
    {
      id: 'good',
      performancePercent: 0.66,
      label: 'Good',
      description: '',
    },
    {
      id: 'very_good',
      performancePercent: 1,
      label: 'Very Good',
      description: '',
    },
  ],
  oralExamDimensionKeys: [] as string[],
};
